import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'actionCost',
    serviceName: 'unitadmin',
    query: gql`
      query actionCost(
        $ids: [String]
        $lab_ids: [String]
        $action_ids: [String]
        $is_active: Int # 0 , >1
        $page: Int
        $limit: Int
        $for_admin: Int # >0 , 1
      ) {
        actionCost(
          ids: $ids
          lab_ids: $lab_ids
          action_ids: $action_ids
          is_active: $is_active
          page: $page
          limit: $limit
          for_admin: $for_admin
        ) {
          total
          data {
            id
            lab {
              title
            }
            action {
              title
            }
          }
        }
      }
    `,
  },
};

export default schema;
